module.exports = __webpack_public_path__ + "static/media/8trumon.ac7441aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/8trumon.png
// module id = 107
// module chunks = 0